import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { registerImageServiceWorker } from './lib/serviceWorker'

registerImageServiceWorker()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

if (import.meta.env.DEV) {
  void import('@stagewise/toolbar-react').then(({ StagewiseToolbar }) => {
    const toolbarRoot = document.createElement('div')
    toolbarRoot.id = 'stagewise-toolbar-root'
    document.body.appendChild(toolbarRoot)

    ReactDOM.createRoot(toolbarRoot).render(
      <React.StrictMode>
        <StagewiseToolbar config={{ plugins: [] }} />
      </React.StrictMode>,
    )
  })
}
